var _g, _defs, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMtrIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    contentScriptType: "text/ecmascript",
    contentStyleType: "text/css",
    viewBox: "0 0 24 23.999999",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.3587 -1.0583)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)",
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m265.2 192.54c-4.7461 0-9.332 1.4219-12.973 3.9531l-35.91-36.07c-0.3164-0.3164-0.63281-0.47265-0.94922-0.78906 4.4297-5.6953 7.1172-12.973 7.1172-20.883 0-11.234-5.3789-21.199-13.605-27.527l14.715-25.945c2.3711 0.78906 5.0625 1.2656 7.75 1.2656 13.449 0 24.523-11.074 24.523-24.523 0-13.445-11.074-24.52-24.68-24.52-13.605 0-24.523 11.074-24.523 24.52 0 7.4375 3.3242 14.082 8.543 18.668l-14.711 25.789c-3.957-1.582-8.3867-2.5312-12.973-2.5312-7.9102 0-15.031 2.6875-20.883 6.9609 0-0.16016-0.16016-0.16016-0.16016-0.31641l-20.09-20.094c1.1055-2.2148 1.7383-4.5859 1.7383-7.1172 0-8.7031-7.1172-15.82-15.82-15.82-8.6992 0-15.82 7.1172-15.82 15.82 0 8.6992 7.1211 15.82 15.82 15.82 2.6914 0 5.2227-0.63281 7.4375-1.8984l20.09 20.09s0.16016 0.16015 0.31641 0.16015c-4.5859 6.0117-7.2773 13.289-7.2773 21.199 0 6.9609 2.0586 13.445 5.5391 18.824l-33.066 28.793c-4.1133-3.0039-9.0156-4.7461-14.555-4.7461-13.289 0-24.363 10.918-24.363 24.363 0 13.449 11.074 24.523 24.523 24.523 13.445 0 24.52-10.918 24.52-24.523 0-4.5859-1.2656-9.0156-3.6367-12.652l32.906-28.477c6.168 5.3789 14.078 8.6992 22.938 8.6992 8.0703 0 15.348-2.6875 21.199-7.2774 0.16016 0.31641 0.47656 0.63282 0.63281 0.94922l35.754 35.914c-2.5312 3.7969-3.9531 8.2266-3.9531 13.129 0 13.133 10.598 23.73 23.73 23.73 13.129 0 23.73-10.598 23.73-23.73 0-13.129-10.441-23.73-23.574-23.73z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)",
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m187.52 111.29c-15.117 0-27.375 12.258-27.375 27.375s12.258 27.375 27.375 27.375c15.121 0 27.375-12.258 27.375-27.375s-12.254-27.375-27.375-27.375zm-5.0234 41.438-12.051-12.055 4.0156-4.0156 8.0352 8.0352 18.082-18.082 4.0156 4.0195z",
    fill: "#6ac259"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 75.369141,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#l",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 108.20799,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#d",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 128.30669,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#b",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 140.97363,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#a",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 161.23708,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#c",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 174.91078,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#g",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 184.85031,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#d",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 204.94901,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#f",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 224.22398,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#e",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 247.41621,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#a",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 267.67966,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#k",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 286.95465,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkHref: "#b",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 131.08008,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#j",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 155.00449,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#a",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 175.26793,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#i",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 196.3734,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#h",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 217.57039,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#c",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.070517 0 0 .070517 -.92156 -.5861)"
  }, /*#__PURE__*/React.createElement("use", {
    x: 231.24409,
    y: 341.85471,
    width: "100%",
    height: "100%",
    xlinkHref: "#b",
    xlinkActuate: "onLoad",
    xlinkShow: "embed",
    xlinkType: "simple"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.5625-26.656 6.8438 19.328 6.8125-19.328h7.2188v26.656h-5.5156v-7.2812l0.54688-12.578-7.1875 19.859h-3.7812l-7.1719-19.844 0.54688 12.562v7.2812h-5.5v-26.656z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.516 0c-0.25-0.47656-0.42969-1.0703-0.53125-1.7812-1.2812 1.4297-2.9492 2.1406-5 2.1406-1.9375 0-3.5469-0.55469-4.8281-1.6719-1.2734-1.125-1.9062-2.5391-1.9062-4.25 0-2.1016 0.77344-3.7109 2.3281-4.8281 1.5625-1.125 3.8125-1.6953 6.75-1.7188h2.4375v-1.125c0-0.91406-0.23438-1.6484-0.70312-2.2031-0.46875-0.55078-1.2148-0.82812-2.2344-0.82812-0.88672 0-1.5859 0.21484-2.0938 0.64062-0.51172 0.42969-0.76562 1.0156-0.76562 1.7656h-5.2812c0-1.1445 0.35156-2.207 1.0625-3.1875 0.70703-0.97656 1.707-1.7422 3-2.2969 1.2891-0.55078 2.7422-0.82812 4.3594-0.82812 2.4375 0 4.375 0.61719 5.8125 1.8438 1.4375 1.2188 2.1562 2.9375 2.1562 5.1562v8.5938c0.0078 1.875 0.26953 3.2969 0.78125 4.2656v0.3125zm-4.375-3.6875c0.78125 0 1.5-0.17188 2.1562-0.51562s1.1445-0.8125 1.4688-1.4062v-3.4062h-1.9844c-2.6484 0-4.0547 0.91797-4.2188 2.75l-0.03125 0.3125c0 0.65625 0.22656 1.1992 0.6875 1.625 0.46875 0.42969 1.1094 0.64062 1.9219 0.64062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.375-24.688v4.875h3.375v3.875h-3.375v9.8906c0 0.74219 0.13281 1.2734 0.40625 1.5938 0.28125 0.3125 0.82031 0.46875 1.625 0.46875 0.58203 0 1.0977-0.046875 1.5469-0.14062v4.0156c-1.0312 0.3125-2.1016 0.46875-3.2031 0.46875-3.7109 0-5.6016-1.8672-5.6719-5.6094v-10.688h-2.8906v-3.875h2.8906v-4.875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.156 0.35938c-2.9062 0-5.2773-0.89062-7.1094-2.6719-1.8242-1.7812-2.7344-4.1562-2.7344-7.125v-0.5c0-1.9883 0.38281-3.7695 1.1562-5.3438 0.76953-1.5703 1.8594-2.7812 3.2656-3.625 1.4141-0.84375 3.0234-1.2656 4.8281-1.2656 2.707 0 4.8359 0.85547 6.3906 2.5625 1.5625 1.7109 2.3438 4.1328 2.3438 7.2656v2.1562h-12.609c0.16406 1.293 0.67578 2.3281 1.5312 3.1094 0.86328 0.78125 1.957 1.1719 3.2812 1.1719 2.0391 0 3.6328-0.73438 4.7812-2.2031l2.5938 2.9062c-0.79297 1.125-1.8672 2-3.2188 2.625-1.3555 0.625-2.8555 0.9375-4.5 0.9375zm-0.60938-16.25c-1.0547 0-1.9062 0.35547-2.5625 1.0625-0.64844 0.71094-1.0625 1.7188-1.25 3.0312h7.3594v-0.42188c-0.02344-1.1641-0.33984-2.0664-0.95312-2.7031-0.60547-0.64453-1.4688-0.96875-2.5938-0.96875z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.172-14.844c-0.73047-0.10156-1.3672-0.15625-1.9062-0.15625-2 0-3.3125 0.67969-3.9375 2.0312v12.969h-5.2969v-19.812h5l0.14062 2.3594c1.0625-1.8125 2.5352-2.7188 4.4219-2.7188 0.58203 0 1.1289 0.07813 1.6406 0.23438z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.625 0h-5.3125v-19.812h5.3125zm-5.625-24.938c0-0.78906 0.26562-1.4414 0.79688-1.9531 0.53125-0.51953 1.2539-0.78125 2.1719-0.78125 0.89453 0 1.6094 0.26172 2.1406 0.78125 0.53906 0.51172 0.8125 1.1641 0.8125 1.9531 0 0.80469-0.27344 1.4648-0.8125 1.9844-0.54297 0.51172-1.2617 0.76562-2.1562 0.76562-0.88672 0-1.6016-0.25391-2.1406-0.76562-0.54297-0.51953-0.8125-1.1797-0.8125-1.9844z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.625 0h-5.3125v-28.125h5.3125z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.453-22.203h-8.1719v22.203h-5.4844v-22.203h-8.0625v-4.4531h21.719z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.766-5.4688c0-0.65625-0.32422-1.1641-0.96875-1.5312-0.63672-0.375-1.6641-0.70703-3.0781-1-4.7188-0.98828-7.0781-2.9883-7.0781-6 0-1.7578 0.72656-3.2266 2.1875-4.4062 1.4688-1.1758 3.3789-1.7656 5.7344-1.7656 2.5078 0 4.5195 0.59375 6.0312 1.7812 1.5078 1.1797 2.2656 2.7148 2.2656 4.6094h-5.2969c0-0.75781-0.24609-1.3828-0.73438-1.875-0.49219-0.5-1.25-0.75-2.2812-0.75-0.89844 0-1.5898 0.20312-2.0781 0.60938-0.49219 0.39844-0.73438 0.90625-0.73438 1.5312 0 0.58594 0.27344 1.0586 0.82812 1.4219 0.5625 0.35547 1.5 0.66797 2.8125 0.9375 1.3203 0.26172 2.4375 0.55859 3.3438 0.89062 2.7891 1.0234 4.1875 2.7969 4.1875 5.3281 0 1.8047-0.77734 3.2617-2.3281 4.375-1.5547 1.1172-3.5547 1.6719-6 1.6719-1.6562 0-3.1328-0.29297-4.4219-0.875-1.293-0.59375-2.3047-1.4062-3.0312-2.4375-0.73047-1.0312-1.0938-2.1445-1.0938-3.3438h5.0156c0.039063 0.9375 0.38281 1.6562 1.0312 2.1562 0.65625 0.5 1.5234 0.75 2.6094 0.75 1.0078 0 1.7734-0.19141 2.2969-0.57812 0.51953-0.38281 0.78125-0.88281 0.78125-1.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.25-9.7656h-4.375v9.7656h-5.5v-26.656h9.9062c3.1562 0 5.5859 0.70312 7.2969 2.1094 1.707 1.3984 2.5625 3.375 2.5625 5.9375 0 1.8242-0.39844 3.3438-1.1875 4.5625-0.78125 1.2109-1.9766 2.1719-3.5781 2.8906l5.7656 10.906v0.25h-5.8906zm-4.375-4.4375h4.4375c1.375 0 2.4375-0.34766 3.1875-1.0469 0.75781-0.70703 1.1406-1.6797 1.1406-2.9219 0-1.25-0.35938-2.2344-1.0781-2.9531-0.71094-0.71875-1.8047-1.0781-3.2812-1.0781h-4.4062z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.859-9.7188c0 3.0547-0.69531 5.4961-2.0781 7.3281-1.3867 1.8359-3.2578 2.75-5.6094 2.75-2 0-3.6172-0.69141-4.8438-2.0781v9.3438h-5.2969v-27.438h4.9062l0.1875 1.9375c1.2812-1.5312 2.9531-2.2969 5.0156-2.2969 2.4375 0 4.332 0.90234 5.6875 2.7031 1.3516 1.8047 2.0312 4.293 2.0312 7.4688zm-5.2812-0.39062c0-1.8438-0.32812-3.2656-0.98438-4.2656s-1.6055-1.5-2.8438-1.5c-1.6562 0-2.7969 0.63672-3.4219 1.9062v8.1094c0.64453 1.3047 1.7969 1.9531 3.4531 1.9531 2.5312 0 3.7969-2.0664 3.7969-6.2031z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.2031-10.094c0-1.957 0.37891-3.707 1.1406-5.25 0.75781-1.5391 1.8477-2.7266 3.2656-3.5625 1.4258-0.84375 3.0781-1.2656 4.9531-1.2656 2.6758 0 4.8594 0.82031 6.5469 2.4531 1.6875 1.6367 2.6289 3.8555 2.8281 6.6562l0.04687 1.3594c0 3.043-0.85156 5.4805-2.5469 7.3125-1.6992 1.8359-3.9805 2.75-6.8438 2.75-2.8555 0-5.1367-0.91016-6.8437-2.7344-1.6992-1.832-2.5469-4.3203-2.5469-7.4688zm5.2969 0.39062c0 1.875 0.35156 3.3125 1.0625 4.3125 0.70703 0.99219 1.7227 1.4844 3.0469 1.4844 1.2812 0 2.2812-0.48828 3-1.4688 0.71875-0.97656 1.0781-2.5508 1.0781-4.7188 0-1.8438-0.35938-3.2695-1.0781-4.2812-0.71875-1.0078-1.7344-1.5156-3.0469-1.5156-1.293 0-2.293 0.50781-3 1.5156-0.71094 1-1.0625 2.5586-1.0625 4.6719z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.355 37.5h202.5v202.5h-202.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m160.15 111.29h54.75v54.75h-54.75z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    x: 214.88853,
    y: 290.10471,
    width: "100%",
    height: "100%",
    xlinkActuate: "onLoad",
    xlinkHref: "#mtr_glyph-0-8",
    xlinkShow: "embed",
    xlinkType: "simple"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtrIcon);
export default __webpack_public_path__ + "static/media/mtr_icon.52272060.svg";
export { ForwardRef as ReactComponent };